import { LegacyBox, styled } from '@gogame/components';

export const SettingsBlocksWrapper = styled(LegacyBox)`
  padding: 16px 0;
  width: 100%;
`;

export const SettingsBlock = styled(LegacyBox)`
  flex-direction: column;
  border-left: ${(props) =>
    props.withBorder ? `1px solid ${props.theme.palette.divider}` : null};
  padding: 0 16px;
  overflow: hidden;
  width: 100%;
`;
